import React from 'react'
import { useAPI } from './APIProvider'
import { useParams } from 'react-router'
import { useAuthUser } from './AuthUserProvider';
import PracticeGroup from 'logic/PracticeGroup'

interface IPracticeGroupContext {
  practiceGroup?: PracticeGroup | null
  reloadPracticeGroup: () => Promise<void>
}

const PracticeGroupContext = React.createContext<IPracticeGroupContext>({} as IPracticeGroupContext)

const PracticeGroupProvider: React.FC = ({ children }) => {
  const params = useParams()
  const { api } = useAPI()
  const { authUser } = useAuthUser()
  const [practiceGroup, setPracticeGroup] = React.useState<PracticeGroup | null>()

  const practiceGroupId = React.useMemo(() => Number(params.practiceGroupId), [params.practiceGroupId]) 

  const reloadPracticeGroup = React.useCallback(async () => {
    if (authUser) {
      try {
        console.log('PracticeGroupProvider: fetchPracticeGroup')
        setPracticeGroup(await api.getPracticeGroup(practiceGroupId))
      } catch (e) {
        console.error(e)
        setPracticeGroup(null)
      }
    } else if (authUser === null) {
      setPracticeGroup(null)
    }
  }, [authUser, api, practiceGroupId])

  React.useEffect(() => {
    reloadPracticeGroup()
  }, [reloadPracticeGroup])

  const value = { 
    practiceGroup, 
    reloadPracticeGroup,
  }
  return (
    <PracticeGroupContext.Provider value={value}>
      {children}
    </PracticeGroupContext.Provider>
  )
}

function usePracticeGroup() {
  const context = React.useContext(PracticeGroupContext)
  if (context === undefined) {
    throw new Error('usePracticeGroup must be used within a PracticeGroupProvider')
  }
  return context
}

export { PracticeGroupProvider, usePracticeGroup }